export default __webpack_public_path__ + "static/media/NanumSquareR.339bcad3.woff2";